<template>
    <div class="policy">      
欢迎您使用魔力数娱的网站、软件及相关服务。<br />
<br />
深圳魔力数娱网络科技有限公司（本协议中简称“魔力数娱”）是本网站、软件及相关服务的提供者，您在使用魔力数娱的相关服务前，应当阅读并遵守《用户服务协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。<br />
<br />
除非您已阅读并接受本协议所有条款，否则您无权使用魔力数娱的服务。您的注册、登录下载、安装、使用等行为即视为您已阅读并同意上述协议的约束。<br />
<br />
如果您未满18周岁，请在法定监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。<br />
<br />
<br />
一、关于本服务<br />
<br />
1.1 本服务的内容<br />
<br />
1.1.1 本服务内容是指魔力数娱向用户（用户是指使用魔力数娱网站、软件及其服务的使用人，本协议中称为“您”）提供的包括但不限于网站、网络游戏、论坛、广告、娱乐等及相关服务（以下简称“本服务”）。<br />
<br />
1.1.2 您使用本服务可能需要连接互联网、下载安装软件、注册账号、支付相关费用等，您应自行支付相关费用。<br />
<br />
1.2 本服务许可的范围<br />
<br />
1.2.1 魔力数娱给予您一项个人的、不可转让及非排他性的许可，以使用本服务。您可以为非商业目的在单一台终端设备上使用本服务。<br />
<br />
1.2.2 您可以为使用服务的目的复制副本，仅用作备份。备份副本必须包含原服务中含有的所有著作权信息。<br />
<br />
1.2.3 本条及本协议其他条款未明示授权的其他一切权利仍由魔力数娱保留，您在行使这些权利时须另外取得魔力数娱的书面许可。魔力数娱如果未行使前述任何权利，并不构成对该权利的放弃。<br />
<br />
<br />
二、账号注册及密码保护<br />
<br />
2.1 您在使用魔力数娱的服务时，可能需要注册一个账号。您应按照服务提示，完成用户注册。完成用户注册后，您享有使用魔力数娱服务的相应权限。如有必要，魔力数娱有权对您的权限进行相应变更。<br />
<br />
2.2 您的账户名不应与已有账户名重名，否则您将不能注册成功。<br />
<br />
2.3您在注册账号或使用昵称时，不得以不雅文字或不恰当文字注册，否则本运营方有权不予注册，或注销您已注册的账号，包括但不限于以下行为：<br />
<br />
2.3.1以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；<br />
<br />
2.3.2以国家机构或其他机构的名称注册；<br />
<br />
2.3.3注册不文明、不健康名字，或包含色情、歧视、侮辱、诽谤、猥亵类词语的账号；<br />
<br />
2.3.4注册易产生歧义、引起他人误解或其它不符合法律规定的账号。<br />
<br />
2.4用户账号的所有权归本运营方所有，您仅享有使用权。若您长时间（超过6个月）未登陆您的账号，本运营方有权收回该账号。<br />
<br />
2.5您应妥善保管密码及保证账号安全。任何人利用您的账号和正确密码登陆您账户并进行一切活动均视为您本人的行为，所引起的任何责任均由您自行承担。如您发现您的账号未经您的授权登陆，您应立即修改密码。如有必要，请通知魔力数娱。<br />
<br />
<br />
三、用户个人信息保护<br />
<br />
3.1 魔力数娱将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可魔力数娱不会向第三方公开、透露用户个人信息。魔力数娱对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。<br />
<br />
3.2 您在使用本服务的过程中，需要提供一些必要的信息，或魔力数娱自动收集您的一些必要信息，例如：设备名称，地理位置信息、手机存储信息等。<br />
<br />
3.3 一般情况下，您可随时浏览、修改自己提交的信息。但若基于身份识别或用户信息安全的考虑，您可能无法修改部分信息。<br />
<br />
3.4 魔力数娱将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。<br />
<br />
3.5 未经您的同意，魔力数娱不会向任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。<br />
<br />
3.6 魔力数娱非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用本服务前，应事先取得您家长或法定监护人的书面同意。<br />
<br />
<br />
四、权利义务条款<br />
<br />
4.1 用户注意事项<br />
<br />
4.1.1 您理解并同意：为了向您提供有效的服务，魔力数娱可能会利用您移动通讯终端的处理器和带宽等资源。<br />
<br />
4.1.2 您理解并同意：本服务的某些功能可能会让第三方知晓用户的信息，例如：您公开的个人头像、您的设备名称或型号等。<br />
<br />
4.1.3您理解并同意魔力数娱将会尽其商业上的合理努力保障您在本服务中的数据存储安全，但是，魔力数娱并不能就此提供完全保证，包括但不限于以下情形：<br />
<br />
4.1.3.1 魔力数娱不对您在本服务中相关数据的删除或储存失败负责；<br />
<br />
4.1.3.2 魔力数娱有权根据实际情况自行决定传输文件的大小限制；<br />
<br />
4.1.3.3魔力数娱不向您提供任何存储文件或数据的服务器空间，您应根据自己的需要自行备份本服务中的相关数据；<br />
<br />
4.1.3.4如果您停止使用本服务或服务被终止或取消，您应自行备份相关数据，魔力数娱不向您提供任何数据。<br />
<br />
4.1.4您在使用本服务时，须自行承担如下来自魔力数娱不可掌控的风险内容，包括但不限于：<br />
<br />
4.1.4.1 由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；<br />
<br />
4.1.4.2 您必须选择与所安装手机相匹配的软件版本，否则，由于软件与手机型号不相匹配所导致的任何问题或损害，均由用户自行承担；<br />
<br />
4.1.4.3 用户在使用本服务访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由您自行承担；<br />
<br />
4.1.4.4 您发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；<br />
<br />
4.1.4.5 由于无线网络信号不稳定、无线网络带宽小等原因，所引起的资料同步不完整、传输速度慢等风险由您自行承担。<br />
<br />
4.2第三方产品和服务<br />
<br />
4.2.1 本服务可能包含第三方产品或服务，您在使用本服务第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。魔力数娱和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。<br />
<br />
4.2.2 因您使用本服务或要求魔力数娱提供特定服务时，本服务可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供，魔力数娱不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与魔力数娱无关，魔力数娱不承担任何责任。<br />
<br />
<br />
五、用户行为规范<br />
<br />
5.1 信息内容规范<br />
<br />
5.1.1 本条所述信息内容是指用户使用本服务过程中所制作、复制、发布、传播的任何内容，包括但不限于音乐、图片、文件、应用、软件等，以及其他使用本服务所产生的内容。<br />
<br />
5.1.2 您理解并同意，魔力数娱一直致力于为用户提供文明健康、规范有序的网络环境，您不得利用本服务制作、复制、发布、传播如下干扰微信正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：<br />
<br />
5.1.2.1 发布、传送、传播、储存违反国家法律法规禁止的内容：<br />
<br />
（1）违反宪法确定的基本原则的；<br />
<br />
（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br />
<br />
（3）损害国家荣誉和利益的；<br />
<br />
（4）煽动民族仇恨、民族歧视，破坏民族团结的；<br />
<br />
（5）破坏国家宗教政策，宣扬邪教和封建迷信的；<br />
<br />
（6）散布谣言，扰乱社会秩序，破坏社会稳定的；<br />
<br />
（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；<br />
<br />
（8）侮辱或者诽谤他人，侵害他人合法权益的；<br />
<br />
（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；<br />
<br />
（10）以非法民间组织名义活动的；<br />
<br />
（11）含有法律、行政法规禁止的其他内容的。<br />
<br />
5.1.2.2 发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；<br />
<br />
5.1.2.3 涉及他人隐私、个人信息或资料的；<br />
<br />
5.1.2.4 发表、传送、传播骚扰、广告信息及垃圾信息或含有任何性或性暗示的；<br />
<br />
5.1.2.5 其他违反法律法规、政策及公序良俗、社会公德或干扰本服务或服务正常运营和侵犯其他用户或第三方合法权益内容的信息。<br />
<br />
5.2 使用规范<br />
<br />
除非法律允许或魔力数娱书面许可，您使用本服务过程中不得从事下列行为：<br />
<br />
5.2.1 删除本服务及其副本上关于著作权的信息；<br />
<br />
5.2.2 对本服务进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本服务的源代码；<br />
<br />
5.2.3 对魔力数娱拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；<br />
<br />
5.2.4 对本服务或者本服务运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本服务运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经魔力数娱授权的第三方工具/服务接入本服务和相关系统；<br />
<br />
5.2.5 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；<br />
<br />
5.2.6 通过非魔力数娱开发、授权的第三方软件、插件、外挂、系统，登录或使用本服务，或制作、发布、传播上述工具；<br />
<br />
5.2.7 自行或者授权他人、第三方软件对本服务及其组件、模块、数据进行干扰；<br />
<br />
5.2.8 其他未经魔力数娱明示授权的行为。<br />
<br />
<br />
5.3 账号异常处理规范<br />
<br />
若账号存在异常（包括但不限于用户的游戏角色、游戏道具、游戏装备、游戏币等账号数据出现异常），魔力数娱有权暂时冻结您的账号；若账号异常行为经魔力数娱判定为非正常游戏行为所致，魔力数娱有权采取下述措施：恢复游戏账号数据至异常发生前的原始状态（包括但不限于向第三方追回被转移数据等），删除游戏账号或其他魔力数娱认为合理的措施，且魔力数娱无须向您承担任何责任。前述账号异常包括但不限于以下情况：<br />
<br />
因游戏软件BUG、软件更新缺陷、第三方病毒攻击或其他任何因素发生异常；<br />
<br />
因第三方交易、账号使用人与实名认证信息不符等导致账号异常或权属存在争议；<br />
<br />
利用非法手段或通过其他未经过魔力数娱授权的第三方充值导致账号异常；<br />
<br />
账号存在恶意退款情形，前述恶意退款包括但不限于用户通过充值获得游戏内道具、资源、装备等增值服务（简称“账号资源”）后，自行进行退款操作而未通过魔力数娱官方公布的客服联系方式通知魔力数娱扣除相应账号资源；<br />
<br />
账号存在违反本用户协议的其他情形。<br />
<br />
魔力数娱未授权任何第三方为用户提供购买、接受赠与或者其他的方式获得游戏账号、游戏道具、游戏装备、游戏币等服务，魔力数娱不对用户通过第三方交易的行为负责，并且不受理任何因用户通过第三方交易发生纠纷而带来的申诉。<br />
<br />
5.4 服务运营规范<br />
<br />
除非法律允许或魔力数娱书面许可，您使用本服务过程中不得从事下列行为：<br />
<br />
5.4.1 提交、发布虚假信息，或冒充、利用他人名义的；<br />
<br />
5.4.2 虚构事实、隐瞒真相以误导、欺骗他人的；<br />
<br />
5.4.3 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；<br />
<br />
5.4.4 利用本服务从事任何违法犯罪活动的；<br />
<br />
5.4.5 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；<br />
<br />
5.4.6 其他违反法律法规规定、侵犯其他用户合法权益、干扰产品正常运营或魔力数娱未明示授权的行为。<br />
<br />
5.5 对自己行为负责<br />
<br />
您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。魔力数娱无法且不会对因前述风险而导致的任何损失或损害承担责任。<br />
<br />
5.6 违约处理<br />
<br />
5.6.1 如果魔力数娱发现或收到他人举报或投诉用户违反本协议约定的，魔力数娱有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部功能。<br />
<br />
5.6.2 您理解并同意，魔力数娱有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。<br />
<br />
5.6.3 您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；魔力数娱因此遭受损失的，您也应当一并赔偿。<br />
<br />
<br />
六、知识产权声明<br />
<br />
6.1 魔力数娱是本服务的知识产权权利人。本服务的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本服务相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，魔力数娱享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。<br />
<br />
6.2 未经魔力数娱或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。<br />
<br />
<br />
七、终端安全责任<br />
<br />
7.1 您理解并同意，本服务同大多数互联网服务一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本服务的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。<br />
<br />
7.2 您不得制作、发布、使用、传播用于窃取微信账号及他人个人信息、财产的恶意程序。<br />
<br />
7.3 维护软件安全与正常使用是魔力数娱和您的共同责任，魔力数娱将按照行业标准合理审慎地采取必要技术措施保护您的终端设备信息和数据安全，但是您承认和同意魔力数娱并不能就此提供完全保证。<br />
<br />
<br />
八、第三方软件或技术<br />
<br />
8.1 本服务可能会使用第三方软件或技术（包括本服务可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。<br />
<br />
8.2 本服务如果使用了第三方的软件或技术，魔力数娱将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、或通过相关页面等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议、其他文件及网页，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求魔力数娱给予协助，您应当自行承担法律责任。<br />
<br />
8.3 如因本服务使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，魔力数娱不承担任何责任。魔力数娱不对第三方软件或技术提供客服支持，若您需要获取支持，请与第三方联系。<br />
<br />
<br />
九、其他<br />
<br />
9.1 您使用本服务即视为您已阅读并同意受本协议的约束。魔力数娱有权在必要时修改本协议条款。您可以在本服务的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本服务。<br />
<br />
9.2 本协议签订地为中华人民共和国广东省深圳市南山区。<br />
<br />
9.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。<br />
<br />
9.4 若您和魔力数娱之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。<br />
<br />
9.5 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。<br />
<br />
9.6 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
    </div>
</template>

<script>


export default {
    name: 'UserAgreement',
    data() {
        return {
            
        };
    },
    
    methods: {
        
    },
    mounted() {
        
    },
};
</script>
<style scoped>

.policy {
    overflow-y: scroll;
}
.policy::-webkit-scrollbar {
      width: 0.1rem;
  }

  .policy::-webkit-scrollbar-thumb {
      background-color: #a18f84;
  }

.van-popup {
  background-color: transparent;
}
  </style>
